import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Alert,
  Button,
  Box,
  MenuItem,
  Snackbar,
  TextField,
} from "@mui/material";
import { Save, Delete } from "@material-ui/icons";
import firebase from "../firebase";

// Add/edit a kid. Reads ?kidID= from the URL; controlled inputs throughout.
export default function KidsForm() {
  const history = useHistory();
  const db = firebase.firestore();

  const params = new URLSearchParams(window.location.search);
  const kidID = params.get("kidID") || "";
  const readOnly =
    params.get("editable") === "false" ||
    window.location.href.includes("sign-in") ||
    window.location.href.includes("signUp");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [age, setAge] = useState("");
  const [location, setLocation] = useState("");
  const [evaluation, setEvaluation] = useState("");
  const [locationData, setLocationData] = useState([]);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const base = db.collection("Main").doc(global.config.uid);

    if (kidID !== "") {
      base
        .collection("Kids")
        .doc(kidID)
        .get()
        .then((doc) => {
          if (doc.exists) {
            setFirstName(doc.data().FirstName || "");
            setLastName(doc.data().LastName || "");
            setAge(doc.data().Age || "");
            setLocation(doc.data().Location || "");
            setEvaluation(doc.data().Eval || "");
          }
        })
        .catch((error) => console.error("Error getting kid:", error));
    }

    const unsub = base.collection("Locations").onSnapshot((snapshot) => {
      setLocationData(
        snapshot.docs.map((doc) => ({ id: doc.id, Location: doc.data().Location }))
      );
    });
    return unsub;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kidID]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const record = {
      FirstName: firstName,
      LastName: lastName,
      Age: age,
      Location: location,
      Eval: evaluation,
    };
    const kidsRef = db.collection("Main").doc(global.config.uid).collection("Kids");

    if (kidID !== "") {
      kidsRef
        .doc(kidID)
        .set(record)
        .then(() => setToast({ severity: "success", message: "Kid updated" }))
        .catch((error) => {
          console.error("Error writing document: ", error);
          setToast({ severity: "error", message: "Could not save — try again" });
        });
    } else {
      kidsRef
        .add(record)
        .then((doc) => {
          setToast({ severity: "success", message: "Kid created" });
          history.replace("/kids-profile?kidID=" + doc.id);
        })
        .catch((error) => {
          console.error("Error creating document: ", error);
          setToast({ severity: "error", message: "Could not save — try again" });
        });
    }
  };

  const handleDelete = () => {
    if (!window.confirm("Are you sure you want to delete this kid?")) return;
    db.collection("Main")
      .doc(global.config.uid)
      .collection("Kids")
      .doc(kidID)
      .delete()
      .then(() => history.push("/kids"))
      .catch((error) => console.error("Error removing document: ", error));
  };

  return (
    <form autoCorrect="off" onSubmit={handleSubmit} id="single-form">
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
        <Box sx={{ display: "flex", gap: 2, flexWrap: { xs: "wrap", sm: "nowrap" } }}>
          <TextField
            required
            fullWidth
            label="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            disabled={readOnly}
          />
          <TextField
            required
            fullWidth
            label="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            disabled={readOnly}
          />
        </Box>
        <Box sx={{ display: "flex", gap: 2, flexWrap: { xs: "wrap", sm: "nowrap" } }}>
          <TextField
            required
            fullWidth
            label="Age"
            value={age}
            onChange={(e) => setAge(e.target.value)}
            disabled={readOnly}
          />
          <TextField
            select
            required
            fullWidth
            label="Location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            disabled={readOnly}
            helperText={locationData.length === 0 ? "Add a location first" : undefined}
          >
            {locationData.map((option) => (
              <MenuItem key={option.id} value={option.Location}>
                {option.Location}
              </MenuItem>
            ))}
          </TextField>
        </Box>
        <TextField
          required
          fullWidth
          multiline
          minRows={4}
          label="Evaluation & Concerns"
          value={evaluation}
          onChange={(e) => setEvaluation(e.target.value)}
          disabled={readOnly}
        />

        {!readOnly && (
          <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
            <Button
              id="save"
              variant="contained"
              color="secondary"
              size="large"
              type="submit"
              startIcon={<Save />}
            >
              {kidID ? "Save Changes" : "Create Kid"}
            </Button>
            {kidID && (
              <Button
                id="delete"
                onClick={handleDelete}
                variant="outlined"
                color="error"
                size="large"
                startIcon={<Delete />}
              >
                Delete
              </Button>
            )}
          </Box>
        )}
      </Box>

      <Snackbar
        open={Boolean(toast)}
        autoHideDuration={3000}
        onClose={() => setToast(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        {toast ? (
          <Alert severity={toast.severity} onClose={() => setToast(null)} sx={{ fontWeight: 600 }}>
            {toast.message}
          </Alert>
        ) : (
          <span />
        )}
      </Snackbar>
    </form>
  );
}
